export default __webpack_public_path__ + "static/media/warning--foggy-road--g1.b2ea0888.png";